import type { StatusVariant } from "../../atoms/StatusPill";
import type { StoryPublishStatus } from "../../../services/dataStories/storiesApi.types";
import type { StoryHeaderNavOption } from "./StoryHeaderActions.types";

/** Pill and dropdown text per publish state — one source for both. */
export const PUBLISH_STATUS_LABEL: Record<StoryPublishStatus, string> = {
  draft: "Draft",
  published: "Published",
};

export const PUBLISH_STATUS_VARIANT: Record<StoryPublishStatus, StatusVariant> = {
  draft: "warning",
  published: "success",
};

/** The status dropdown's rows, in menu order. */
export const PUBLISH_STATUS_OPTIONS: StoryHeaderNavOption<StoryPublishStatus>[] = (
  ["draft", "published"] as const
).map((value) => ({ value, label: PUBLISH_STATUS_LABEL[value] }));

/** Shown under a share row that can't be used while the story is still generating. */
export const SHARE_OPTION_DISABLED_NOTE = "Available once your story finishes generating";
/** F17 share menu width (300px). GAP: no 300 spacing token. */
export const SHARE_MENU_WIDTH = "18.75rem";
/** GAP: F17 menu shadow (0 20px 40px -8px ink at .26) has no shadow token. */
export const SHARE_MENU_SHADOW = "0 20px 40px -8px rgba(24, 16, 43, 0.26)";
/** GAP: F17 icon tile is 30px; no 30px spacing token. */
export const SHARE_ICON_TILE = "1.875rem";
